import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default'),
    whiteSpace: 'nowrap'
  }
}))

export default useStyles
